// @flow

import { getActiveBundle } from './bundles';
import { getActiveClaimFree } from './claimFree';
import { getActiveColor } from './color';
import { getActiveDuration } from './duration';
import { getActiveMileage } from './mileage';
import { getActivePackage } from './package';
import { getActiveAccessoriesByMethod } from './accessories';
import { getActiveNonRecurringContracts } from './extraContracts';
import type { State as ConfigState } from '../../types';
import type { State as PdbState } from '../../../pdb/types';
import type { OrderFormState } from '../../../orderForm/types';

type GlobalState = {
  configuration: ConfigState,
  pdb: PdbState,
  orderForm: OrderFormState,
};

export const configBuilderSelectorMap = {
  bundles: getActiveBundle,
  claim_free: getActiveClaimFree,
  colors: getActiveColor,
  durations: getActiveDuration,
  mileages: getActiveMileage,
  packages: getActivePackage,
  extras: (state: GlobalState, pdbId?: ?string) => getActiveAccessoriesByMethod(state, 'selected', true, pdbId),
  insurances: (state: GlobalState, pdbId?: ?string) => getActiveNonRecurringContracts(state, 'selected', true, pdbId),
};

export const getActiveByConfigBuilderType = (
  state: GlobalState,
  cbType: string,
  pdbId?: ?string,
) => {
  const getActive = configBuilderSelectorMap[cbType];
  if (!getActive) {
    return null;
  }
  return getActive(state, pdbId);
};

export default null;
